<template>
  <v-form>
    <v-container class="py-0">
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="newItemData.title"
            :label="$t('title_field')"
            required
            outlined
          />
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="newItemData.language"
            :items="languages"
            item-text="label"
            item-value="value"
            :label="$t('language_field')"
            persistent-hint
            single-line
            required
            outlined
          />
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="newItemData.description"
            :label="$t('description_field')"
            required
            outlined
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="newItemData.category"
            :label="$t('category_field')"
            maxlength="20"
            required
            outlined
          />
        </v-col>
        <v-col cols="12">
          <v-menu
            ref="date_menu"
            v-model="date_menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="newItemData.date"
                color="purple"
                :label="$t('date')"
                readonly
                v-bind="attrs"
                v-on="on"
                required
                outlined
              />
            </template>
            <v-date-picker
              v-model="newItemData.date"
              :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
            />
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
export default {
  name: 'GeneralTab',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    newItemData: {},
    date_menu: false,
    languages: [
      { label: 'Українська', value: 'uk' },
      { label: 'English', value: 'en' },
      { label: 'Deutschland', value: 'de' },
    ],
  }),
  mounted () {
    this.newItemData = this.item
  },
}
</script>
